import API from '@/services/APIService';

export default {
	name: 'TenantService',
	getTenantList() {
		return API.call('/tenant/list',{},"Auth");
	},
};